<template>
    <generic-chat-modal 
        ref="chatModal" 
        :modal-title="chatConfig.title"
        :new-conversation-subtitle="chatConfig.subtitle"
        :new-conversation-search-placeholder="chatConfig.searchPlaceholder" 
        :api-base-path="chatConfig.apiBasePath"
        :entity-key="chatConfig.entityKey" 
        :entity-id-key="chatConfig.entityIdKey"
        @update-unread-count="$emit('update-unread-count', $event)" />
</template>

<script>
import GenericChatModal from '@/Shared/Chat/GenericChatModal'
import { computed } from 'vue'
import { usePage } from '@inertiajs/inertia-vue3'

export default {
    components: {
        GenericChatModal,
    },
    emits: ['update-unread-count'],
    setup() {
        const user = computed(() => usePage().props.value.auth.user)

        const chatConfig = computed(() => {
            const role = user.value?.role
            const hasAgencyId = !!user.value?.agency_id
            const isSuperAdminWithAgency = user.value?.super_admin_agency === true
            
            const isSuperAdmin = role === 1 && (!hasAgencyId || isSuperAdminWithAgency)
            const isAdmin = role === 2
            const isAgency = role === 1 && hasAgencyId && !isSuperAdminWithAgency
            const isProvider = role === 3

            // SuperAdmin (role 1 sem agency) ou Admin (role 2)
            if (isSuperAdmin || isAdmin) {
                return {
                    title: 'Mensagens das agências',
                    subtitle: 'Selecione uma agência para começar a conversar.',
                    searchPlaceholder: 'Buscar agência por nome ou CNPJ',
                    apiBasePath: '/chat',
                    entityKey: 'agency',
                    entityIdKey: 'agency_id'
                }
            }

            // Agency
            if (isAgency) {
                return {
                    title: 'Mensagens',
                    subtitle: 'Selecione um contato para começar a conversar.',
                    searchPlaceholder: 'Buscar por nome ou email',
                    apiBasePath: '/agency-chat',
                    entityKey: 'user',
                    entityIdKey: 'user_id'
                }
            }

            // Provider
            if (isProvider) {
                return {
                    title: 'Mensagens das agências',
                    subtitle: 'Selecione uma agência para começar a conversar.',
                    searchPlaceholder: 'Buscar agência por nome ou CNPJ',
                    apiBasePath: '/provider/chat',
                    entityKey: 'agency',
                    entityIdKey: 'agency_id'
                }
            }

            // Fallback
            return {
                title: 'Mensagens',
                subtitle: 'Selecione um contato para começar a conversar.',
                searchPlaceholder: 'Buscar',
                apiBasePath: '/chat',
                entityKey: 'user',
                entityIdKey: 'user_id'
            }
        })

        return {
            user,
            chatConfig
        }
    },
    methods: {
        openModal() {
            this.$refs.chatModal?.openModal()
        },
        closeModal() {
            this.$refs.chatModal?.closeModal()
        },
        toggleModal() {
            this.$refs.chatModal?.toggleModal()
        }
    }
}
</script>
